import { paddingXXL } from "src/styles/spacing";

export const GatheringViewerRowHeight = 76;
export const GatheringViewerHorizontalPadding = paddingXXL;
